var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPollyTabsBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 27.75H8.25V11.75H31.25V27.75ZM9.25 26.75H30.25V12.75H9.25V26.75ZM28.25 10.75H27.25V8.75H5.25V23.75H7.25V24.75H4.25V7.75H28.25V10.75ZM24.75 6.75H23.75V5.25H1.75V20.25H3.25V21.25H0.75V4.25H24.75V6.75Z",
    fill: "#00BDD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollyTabsBlue);
export default __webpack_public_path__ + "static/media/PollyTabsBlue.b7df8ac193facbf03f84f4fc4e17fc64.svg";
export { ForwardRef as ReactComponent };